import React, { useCallback } from 'react';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from "react-router-dom";
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import { updateCategoryAction, getSelectedCategoryAction,getCategoryTypeAction } from '../../../store/actions/CategoryActions';


const EditCategory = (props) => {
     

    const categoryid = props.categoryid;

   // console.log(categoryid);
   
    const categorySelected = useSelector((state) => state.allCategories.category?.payload);
    const categoryTypes = useSelector((state) => state.allCategories?.categoryType?.payload);

    const categoryTypeOptions = categoryTypes?.map(category => {
        const option = {};
        option['value'] = category.id;
        option['label'] = category.name;
        return option;
    });

    const dispatch = useDispatch();
    const [submit, setSubmit] = useState(true);

    const [category, setCategory] = useState({
        name: "",
        description: "",
        category_type_id:""
    });

   
   
    function onFormFieldChange(e) {
        console.log(e.target.value);
        if (e.target.value === '') {
            setSubmit(false);
        } else {
            setSubmit(true);
        }
        setCategory({
            ...category,
            [e.target.name]: e.target.value
        });
    }


    function onFormSelectChange(e) {
        console.log(e.target.name);
        setCategory({
            ...category,
            [e.target.name]: e.target.value
        });

        console.log(category);
    }


    function onFormSubmit(e) {
        e.preventDefault();
        try {
            // await createCategory(category);
            dispatch(updateCategoryAction(category, categoryid, props.handleDetailsSidebar));
        } catch (error) {
            console.log("Something is wrong");
        }
    }


    function getCategory(categoryid) {
        dispatch(getSelectedCategoryAction(categoryid));
    }


    useEffect(() => {
        getCategory(categoryid);
    }, [categoryid]);

    useEffect(() => {
        if (categorySelected) {
            setCategory({
                ...categorySelected
            });
        }
    }, [categorySelected]);

   

    function fetchCategoryTypes() {
        dispatch(getCategoryTypeAction());
    }

    useEffect(() => {
        fetchCategoryTypes();
    }, []);
    

    return (
        <div className='category'>
            <div style={{ height: "240vh", overflow: "scroll" }}>
                <div className="card rounded-0 add-menu-card">
                    <div className="card-header">
                        <b>Category Details</b>
                        {submit && <button className='btn btn-xs rounded-0' type='submit' onClick={onFormSubmit} style={{ color: 'white', backgroundColor: '#000000' }}>Save</button>}
                    </div>
                    <Alert severity="info">
                        Individual menu items will be grouped in the categories when shown to customers.
                        Please ensure that names and descriptions are correct as they will be visible to customers.
                    </Alert>
                    <div className='catery-add-form'>
                        <form>
                            <TextField id="standard-basic" label="Category Name *" name="name" variant="standard" onChange={onFormFieldChange} value={category?.name || '' } />
                            <div className='mt-5' >

                                <FormControl variant="standard" sx={{ m: 1, minWidth: 535 }}>
                                    <InputLabel id="demo-simple-select-standard-label">Category Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        value={category?.category_type_id || ''}
                                        onChange={onFormSelectChange}
                                        label="Category Type"
                                        name="category_type_id"
                                    >
                                        {categoryTypeOptions?.map((option) => (
                                            <MenuItem key={option?.value} value={option?.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className='mt-5'>
                                <TextField id="standard-basic" value={category?.description || ''} name="description" label="Category Description(optional)" variant="standard" onChange={onFormFieldChange} />
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default EditCategory;